import CompanyPromo from '@/components/company-promo/company-promo';
export default CompanyPromo;
